import cx from 'classnames';
import PropTypes from 'prop-types';

import { DOCUMENT_LOCKED_SCORE_PANEL_HEIGHT, DOCUMENT_SCORE_PANEL_HEIGHT } from 'src/data/ui';

import { useStyles } from './useStyles';

const calcPanelTop = (boundaries, locked) => {
  const height = locked ? DOCUMENT_LOCKED_SCORE_PANEL_HEIGHT : DOCUMENT_SCORE_PANEL_HEIGHT;
  return boundaries?.middle - height / 2 || 0;
};

export const DocumentScoreContainer = ({ className, boundaries, locked, children }) => {
  const styles = useStyles();
  const topPosition = calcPanelTop(boundaries, locked);

  return (
    <div
      className={cx(styles.root, className)}
      style={{ top: topPosition }}
    >
      {children}
    </div>
  );
};

DocumentScoreContainer.propTypes = {
  className: PropTypes.string,
  boundaries: PropTypes.shape({}).isRequired,
  locked: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

DocumentScoreContainer.defaultProps = {
  className: '',
  locked: false,
};
